import { render, staticRenderFns } from "./Speed.vue?vue&type=template&id=e5c37a0e&scoped=true&"
import script from "./Speed.vue?vue&type=script&lang=js&"
export * from "./Speed.vue?vue&type=script&lang=js&"
import style0 from "./Speed.vue?vue&type=style&index=0&id=e5c37a0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c37a0e",
  null
  
)

export default component.exports